var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-xs"},[_vm._v("\n  "+_vm._s(_vm.$t('GENERAL.SHOWING_RESULTS', {
      firstIndex: _vm.firstIndex,
      lastIndex: _vm.lastIndex,
      totalCount: _vm.totalCount,
    }))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }